import { Directive, HostListener, signal } from '@angular/core';
import { CeFormFieldComponent } from './ce-form-field.component';

@Directive({
    selector: 'input[ce-input], textarea[ce-input]',
    standalone: true,
    host: {
        class: 'CeInput',
    },
})
export class CeInputDirective {
    isFocused = signal<boolean>(false);

    @HostListener('focus') onFocus() {
        this.isFocused.set(true);
    }

    @HostListener('blur') onBlur() {
        this.isFocused.set(false);
    }
}

@Directive({
    selector: '[ce-input-prefix]',
    standalone: true,
    host: {
        class: 'CeInputPrefix u-spacing-sm-mr',
    },
})
export class CeInputPrefixDirective {}

@Directive({
    selector: '[ce-input-error]',
    standalone: true,
    host: {
        class: 'CeInputError',
    },
})
export class CeInputErrorDirective {}

/**
 * @deprecated Use `[ce-input-hint-persistent]` instead. This "toggle" hint lives in the
 * collapsible error-space row (it's hidden when `[hideErrorSpace]` is set), whereas the
 * persistent hint always renders below the field. New code should use the persistent slot;
 * this one is kept only for existing consumers and will be removed once they migrate.
 */
@Directive({
    selector: '[ce-input-hint]',
    standalone: true,
    host: {
        class: 'CeInputHint CeInputHint-toggle',
    },
})
export class CeInputHintDirective {}

@Directive({
    selector: '[ce-input-hint-persistent]',
    standalone: true,
    host: {
        class: 'CeInputHint CeInputHint-persistent',
    },
})
export class CeInputHintPersistentDirective {}
export const CeInputImports = [CeInputHintPersistentDirective, CeInputHintDirective, CeInputErrorDirective, CeInputDirective, CeInputPrefixDirective, CeFormFieldComponent] as const;
